import axios, { AxiosRequestConfig } from 'axios';
// config
import { HOST_API, HOST_BONUS_API } from 'src/config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: HOST_API });

axiosInstance.interceptors.response.use(
  (res) => res,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcherGet = async (args: string | [string, AxiosRequestConfig, string?]) => {
  const [url, config, baseURL] = Array.isArray(args) ? args : [args];

  if (baseURL === 'bonus') {
    axiosInstance.defaults.baseURL = HOST_BONUS_API;
  }

  const res = await axiosInstance.get(url, { ...config });

  return res.data;
};

export const fetcherPost = async (args: string | [string, AxiosRequestConfig, string?]) => {
  const [url, config, baseURL] = Array.isArray(args) ? args : [args];

  if (baseURL === 'bonus') {
    axiosInstance.defaults.baseURL = HOST_BONUS_API;
  }

  const res = await axiosInstance.post(url, { ...config });

  return res.data;
};

// ----------------------------------------------------------------------

export const endpoints = {
  chat: '/api/chat',
  kanban: '/api/kanban',
  calendar: '/api/calendar',
  auth: {
    me: '/users/auth/me',
    login: '/users/authenticate',
    register: '/api/auth/register',
  },
  users: {
    list: '/users/list',
    details: '/users/getById',
    update: '/users/update',
    create: '/users/insert',
    delete: '/users/delete',
  },
  level: {
    list: '/avatarLevel/list',
    details: '/avatarLevel/getById',
    update: '/avatarLevel/update',
    create: '/avatarLevel/insert',
    delete: '/avatarLevel/delete',
  },
  quest: {
    list: '/world/list',
    details: '/world/getById',
    update: '/world/update',
    create: '/world/insert',
    delete: '/world/delete',
  },
  languages: {
    list: 'language/list',
  },
  games: {
    list: '/casinogame/list',
    details: '/casinogame/getbyid',
    update: '/casinogame/update',
    create: '/casinogame/insert',
    delete: '/casinogame/delete',
    import: '/casinogame/import',
    displayOrder: '/casinogame/displayordergetbyid',
    insertDisplay: '/casinogame/insertupdatedisplay',
    lobby: '/casinogame/lobby',
  },
  categories: {
    list: '/casinocategory/list',
    details: '/casinocategory/getbyid',
    update: '/casinocategory/update',
    create: '/casinocategory/insert',
    delete: '/casinocategory/delete',
  },
  vendors: {
    list: '/casinovendor/list',
    details: '/casinovendor/getbyid',
    update: '/casinovendor/update',
    create: '/casinovendor/insert',
    delete: '/casinovendor/delete',
  },
  lobbyBlocks: {
    list: '/lobbyblock/list',
    details: '/lobbyblock/getbyid',
    update: '/lobbyblock/update',
    create: '/lobbyblock/insert',
    delete: '/lobbyblock/delete',
  },
  mail: {
    list: '/api/mail/list',
    details: '/api/mail/details',
    labels: '/api/mail/labels',
  },
  post: {
    list: '/api/post/list',
    details: '/api/post/details',
    latest: '/api/post/latest',
    search: '/api/post/search',
  },
  product: {
    list: '/api/product/list',
    details: '/api/product/details',
    search: '/api/product/search',
  },
  tags: {
    list: '/casinogame/listtags',
  },
  bonusProgram: {
    findAll: 'bonus-engine/bonus/findAll' as 'bonus-engine/bonus/findAll',
    findOne: 'bonus-engine/bonus/findBonus' as 'bonus-engine/bonus/findBonus',
    findProviders: 'bonus-engine/bonus/getProviders' as 'bonus-engine/bonus/getProviders',
    findProvidersCategory:
      'bonus-engine/bonus/getProvidersCategories' as 'bonus-engine/bonus/getProvidersCategories',
    findGamesProvider: 'bonus-engine/bonus/getGames' as 'bonus-engine/bonus/getGames',
    create: 'bonus-engine/bonus/create' as 'bonus-engine/bonus/create',
    update: 'bonus-engine/bonus/update' as 'bonus-engine/bonus/update',
    delete: 'bonus-engine/bonus/delete' as 'bonus-engine/bonus/delete',
  },
};
